import React, { useEffect, useState } from "react";
import VitalSigns from '../../../../globalcomponents/patient360/medicalhistory/vitalsigns'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientVitalSigns = (props) => {
  return (
    <>
      <VitalSigns data={props.formValues.patientdata} app="Site" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientVitalSigns));

